// SPDX-License-Identifier: AGPL-3.0-or-later
const MONTHS = {
    jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6, jul: 7, aug: 8, sep: 9, sept: 9, oct: 10, nov: 11, dec: 12,
    // French abbreviations, for French-language exports.
    janv: 1, fév: 2, fev: 2, mars: 3, avr: 4, mai: 5, juin: 6, juil: 7, août: 8, aout: 8, déc: 12,
};
function pad(n) {
    return String(n).padStart(2, "0");
}
function valid(y, m, d) {
    if (m < 1 || m > 12 || d < 1)
        return false;
    return d <= new Date(Date.UTC(y, m, 0)).getUTCDate();
}
/**
 * Parses the date formats Canadian banks use into an ISO date.
 * Numeric dates like 04/10/2026 are ambiguous, so the profile says which
 * order to use. Returns null if the text is not a date.
 */
export function parseDate(text, order = "MDY") {
    const t = text.trim();
    let m = /^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})/.exec(t);
    if (m) {
        const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
        return valid(y, mo, d) ? `${y}-${pad(mo)}-${pad(d)}` : null;
    }
    m = /^(\d{1,2})[-/.](\d{1,2})[-/.](\d{2,4})$/.exec(t);
    if (m) {
        const a = Number(m[1]);
        const b = Number(m[2]);
        let y = Number(m[3]);
        if (y < 100)
            y += 2000;
        const [mo, d] = order === "DMY" ? [b, a] : [a, b];
        return valid(y, mo, d) ? `${y}-${pad(mo)}-${pad(d)}` : null;
    }
    m = /^(\d{1,2})[\s-]+([A-Za-zÀ-ÿ]{3,5})\.?[\s-]+(\d{4})$/.exec(t);
    if (m) {
        const mo = MONTHS[m[2].toLowerCase()];
        const [y, d] = [Number(m[3]), Number(m[1])];
        return mo && valid(y, mo, d) ? `${y}-${pad(mo)}-${pad(d)}` : null;
    }
    m = /^([A-Za-z]{3,5})\.?\s+(\d{1,2}),?\s+(\d{4})$/.exec(t);
    if (m) {
        const mo = MONTHS[m[1].toLowerCase()];
        const [y, d] = [Number(m[3]), Number(m[2])];
        return mo && valid(y, mo, d) ? `${y}-${pad(mo)}-${pad(d)}` : null;
    }
    return null;
}
/**
 * Parses an amount into cents. Handles "$1,234.56", "-12.30", "(12.30)",
 * "12.30 CR", "12,30 $" (French format) and blanks (null).
 */
export function parseAmount(text) {
    let t = text.trim();
    if (t === "")
        return null;
    let negative = false;
    if (/^\(.*\)$/.test(t)) {
        negative = true;
        t = t.slice(1, -1);
    }
    if (/\b(DR|DB)\b\.?$/i.test(t)) {
        negative = true;
        t = t.replace(/\b(DR|DB)\b\.?$/i, "");
    }
    t = t.replace(/\b(CR)\b\.?$/i, "");
    t = t.replace(/[$\s  ]|CAD|USD/gi, "");
    if (t.startsWith("-")) {
        negative = !negative;
        t = t.slice(1);
    }
    else if (t.endsWith("-")) {
        negative = !negative;
        t = t.slice(0, -1);
    }
    else if (t.startsWith("+")) {
        t = t.slice(1);
    }
    // French style uses a comma for decimals: 1 234,56
    if (/^\d{1,3}(\.\d{3})*,\d{1,2}$/.test(t) || /^\d+,\d{1,2}$/.test(t)) {
        t = t.replace(/\./g, "").replace(",", ".");
    }
    else {
        t = t.replace(/,/g, "");
    }
    if (!/^\d+(\.\d+)?$/.test(t))
        return null;
    const cents = Math.round(Number(t) * 100);
    return negative ? -cents : cents;
}
/** Collapses spacing and case so the same payee always matches. */
export function normalizeDescription(text) {
    return text.replace(/\s+/g, " ").trim().toUpperCase();
}
//# sourceMappingURL=parse.js.map